import { render, staticRenderFns } from "./basicLayout.vue?vue&type=template&id=b97ae46a&scoped=true"
import script from "./basicLayout.vue?vue&type=script&lang=js"
export * from "./basicLayout.vue?vue&type=script&lang=js"
import style0 from "./basicLayout.vue?vue&type=style&index=0&id=b97ae46a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b97ae46a",
  null
  
)

export default component.exports